import { CancelEnclosedIcon } from '@airtel/air-design-system';
import { StyleSheet, TouchableOpacity } from 'react-native';

interface ModalCloseButtonProps {
   onPress?: (isOpen: boolean) => void;
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ onPress }) => {
   return (
      <TouchableOpacity style={styles.button} onPress={() => onPress?.(false)}>
         <CancelEnclosedIcon width={40} height={40} color={'rgba(256,256,256,0.65)'} />
      </TouchableOpacity>
   );
};

const styles = StyleSheet.create({
   button: {
      position: 'absolute',
      top: 16,
      right: 16,
      zIndex: 1000000,
   },
});

export default ModalCloseButton;
